export default __webpack_public_path__ + "static/media/Ballroll_00212.f84b96fb.png";